import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import ls from 'local-storage';
import ManageAccountLinks from "../../Component/ManageAccountLinks/ManageAccountLinks"
import API from "../../Services/BaseService";
import '../../Component/Popup/popup.css';
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import { useSelector } from 'react-redux';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import Loading from "../../Component/Loading/Loading";
import PageNotFound from '../FallBackUI/PageNotFound';

const LotFee = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath] = useState("")
    const [lotFee, setLotFee] = useState("")
    const [lotValue, setLotValue] = useState("");
    const successData = useSelector(state => state.LoginReducer.payload);
    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    console.log("lotfee=== successData:==",successData)
    const togglePopup = () => {
        setIsOpen(!isOpen);
    }
    async function getLotfee() {
        let request = {
            seller_dealer_id: successData.seller_dealer_id,
        };
        const state = API.post('seller_lot_fee/condition', request);
        state.then(res => {
            console.log("res", res.data.data)
            if (res.data.success === true) {
            setLotValue(res.data.data.seller_lot_fee);
            setLotFee(res.data.data)
            setLoading(false);
       }
        else {
            setErrors(res.data.error)
            setErrorFlag(true)
        }
               
            }) 
            .catch(function (error) {
              if (error.response) {
                  setErrors(error.response.data.error)
                  setErrorFlag(true)
                  setLoading(false);
              }
          });
    }
    useEffect(() => {
        getLotfee();
    }, []);
    // useEffect(() => {},[lotValue]);
    const updateLotValue = (data) => {
        console.log("---------------", data)
        if (!isNaN(data) && data !== "" && data !== undefined) {
            console.log(data);
            setLotValue(data)
        }
        else{
            //setLotValue(0)
        }
            
    }

    const handlesubimt = () => {
        //console.log("check",buyer_id)
        let request = {
            seller_dealer_id: successData.seller_dealer_id,
            seller_lot_fee: lotValue,
            active: 1
        };
        
        API.post("seller_lot_fee/add", request)
            .then((response) => {
                console.log("res", response.data.success)
                if (response.data.success) {
                    togglePopup()
                    setPopupTitle("Create LotFee");
                    setPopupMsg("LotFee Successfully Created");
                    setPopupType("success");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                    // setPopupActionPath("/lotfee")
                } else {
                    togglePopup()
                    setPopupTitle("Create LotFee");
                    // setPopupMsg("LotFee is not Created, Please try Again");
                    setPopupMsg(response.data.error.err);
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                }
            },
                (error) => {
                    togglePopup()
                    setPopupTitle("Error");
                    setPopupMsg("Something went wrong, Please try Again");
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                })
                .catch(function (error) {
                    if (error.response) {
                        setErrors(error.response.data.error)
                        setErrorFlag(true)
                    }
                });
    }

    return (
        <div>
            {loading ? <Loading /> :
            <main id="main" className="inner-page">
            {errorFlag === true ? <PageNotFound error={errors} /> :
                <div id="lotfee" className="lotfee">
	
                    <div className="container">
                        <div className="lotfeeblock col-lg-12">
                            <div className="section-title">
                                <h2>Lot Fee</h2>
                            </div>
                            <div className="row content">
                                <div className="col-lg-3 col-md-4 col-sm-12 accountleftblock">
                                    <ManageAccountLinks />
                                </div>
                                <div className="col-lg-9 col-md-8 col-sm-12 pt-4 pt-lg-0 lotfeerightblock">
                                    <div className="lotfee-inner">
                                        <p>Your expense or your profit added to the vehicle every time you purchase </p>
                                        <div className="form-group col-lg-6 col-md-6 lotfee-form">
                                            <div className="input-icon">
                                                <input type="text" className="form-control" defaultValue={lotFee.lot_fee} value={lotValue} onChange={(e) => updateLotValue(Math.round(e.target.value))} />
                                                <i>$</i>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 loginBtn">
                                            <button className="cta-btn" onClick={handlesubimt}>Submit</button>
                                            {/* conclick={handlesubimt} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
                <section id="playstoreBlock" className="playstoreBlock">
                    <div className="container">
                        <div className="row content">
                            <div className="col-lg-12">
                            <img src={appstore} />
			                <img src={googleplay} />
                            </div>
                        </div>
                    </div>
                </section>
                {isOpen &&
                    <CommonPopup
                        handleClose={togglePopup}
                        popupTitle={popupTitle}
                        popupMsg={popupMsg}
                        popupType={popupType}
                        popupActionType={popupActionType}
                        popupActionValue={popupActionValue}
                        popupActionPath={popupActionPath}
                    />}
            </main>}
        </div>
    )
}

export default LotFee;